export const ONBOARDING_TITLE = {
  pt: "Criar sua conta",
  es: "Crear tu cuenta",
  en: "Create your account",
};

export const ONBOARDING_SUBTITLE = {
  pt: "Preencha seus dados para se cadastrar. Um administrador precisará liberar seu acesso depois.",
  es: "Rellene sus datos para registrarse. Un administrador deberá liberar su acceso.",
  en: "Fill in your data to register. An admin will need to approve your access afterwards.",
};

export const EMAIL = {
  pt: "E-mail",
  es: "Correo electrónico",
  en: "E-mail",
};

export const DISPLAY_NAME = {
  pt: "Nome completo",
  es: "Nombre completo",
  en: "Full name",
};

export const PASSWORD = {
  pt: "Senha",
  es: "Contraseña",
  en: "Password",
};

export const PASSWORD_CONFIRMATION = {
  pt: "Confirmar senha",
  es: "Confirmar contraseña",
  en: "Confirm password",
};

export const SUBMIT = {
  pt: "Cadastrar",
  es: "Registrarse",
  en: "Sign up",
};

export const BACK_TO_LOGIN = {
  pt: "Já tem conta? Entrar",
  es: "¿Ya tiene cuenta? Iniciar sesión",
  en: "Already have an account? Log in",
};

export const REQUIRED = {
  pt: "Campo obrigatório",
  es: "Campo obligatorio",
  en: "Required field",
};

export const INVALID_EMAIL = {
  pt: "E-mail inválido",
  es: "Correo electrónico inválido",
  en: "Invalid e-mail",
};

export const PASSWORDS_DO_NOT_MATCH = {
  pt: "As senhas não coincidem",
  es: "Las contraseñas no coinciden",
  en: "Passwords do not match",
};

export const PASSWORD_RULE_LENGTH = {
  pt: "Mínimo de 8 caracteres",
  es: "Mínimo de 8 caracteres",
  en: "At least 8 characters",
};

export const PASSWORD_RULE_UPPER = {
  pt: "Ao menos 1 letra maiúscula",
  es: "Al menos 1 letra mayúscula",
  en: "At least 1 uppercase letter",
};

export const PASSWORD_RULE_LOWER = {
  pt: "Ao menos 1 letra minúscula",
  es: "Al menos 1 letra minúscula",
  en: "At least 1 lowercase letter",
};

export const PASSWORD_RULE_NUMBER = {
  pt: "Ao menos 1 número",
  es: "Al menos 1 número",
  en: "At least 1 digit",
};

export const ERROR_EMAIL_IN_USE = {
  pt: "Este e-mail já está cadastrado. Faça login ou use outro e-mail.",
  es: "Este correo ya está registrado. Inicie sesión o use otro correo.",
  en: "This e-mail is already registered. Log in or use another e-mail.",
};

export const ERROR_INVALID_EMAIL = {
  pt: "E-mail inválido",
  es: "Correo electrónico inválido",
  en: "Invalid e-mail",
};

export const ERROR_WEAK_PASSWORD = {
  pt: "Senha muito fraca",
  es: "Contraseña muy débil",
  en: "Password too weak",
};

export const ERROR_NETWORK = {
  pt: "Sem conexão. Tente novamente.",
  es: "Sin conexión. Inténtelo de nuevo.",
  en: "Network error. Try again.",
};

export const ERROR_GENERIC = {
  pt: "Algo deu errado. Tente novamente.",
  es: "Algo salió mal. Inténtelo de nuevo.",
  en: "Something went wrong. Try again.",
};

export const ERROR_MONGO_INCONSISTENT = {
  pt: "Cadastro parcial. Contate o suporte informando seu e-mail.",
  es: "Registro parcial. Contacte al soporte informando su correo.",
  en: "Partial signup. Contact support and mention your e-mail.",
};
